import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Divider, FormControl, FormControlLabel, FormHelperText, IconButton, InputLabel, ListItemText, MenuItem, Select, TextField, Tooltip, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CommentDrawer from '../Common/Drawer';
// import ReactQuill from "react-quill";
import { createDomain, fetchLocations, updateDomain } from '../../store/domainSlice';
import CustomSwitch from '../Common/CustomSwitch';
import InfoIcon from '@mui/icons-material/Info';
import { CloseRounded, Key } from '@mui/icons-material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { fetchLandingPages } from '../../store/LandPageSlice';
import FileUploader from '../Common/FileUploader';
import isEqual from 'lodash/isEqual';
import Editor from 'react-simple-wysiwyg';
import _ from 'lodash';


export default function DomainForm({ title, domainModal, setDomainModal, resetTrigger, fetchDomainsDetails, selectedDomain = null }) {
    const dispatch = useDispatch();
    const [isButtonDisabled, setIsButtonDisabled] = React.useState();
    const [page, setPage] = React.useState(0);
    const [route, setRoute] = useState('');
    // const [valueChangeCount, setvalueChangeCount] = useState(0);
    const [filePreview, setFilePreview] = useState(null);
    const [slug, setSlug] = useState("");
    const [fileType, setFileType] = useState(null);
    const fbLocations = useSelector((state) => state.domainReducer.fbLocations)
    const industries = useSelector((state) => state.industryReducer.industryList)


    const validationSchema = Yup.object({
        contact: Yup.string()
            .matches(/^\+?(\d.*){10,}$/, 'Phone number is not valid')
            .when('is_affiliate', {
                is: true,
                then: (schema) => schema, // optional
                otherwise: (schema) => schema.required('Contact number is required'),
            })
            .trim(),

        use_domain_info: Yup.boolean(),
        is_affiliate: Yup.boolean(),
        route: Yup.string().when('is_affiliate', {
            is: true,
            then: (schema) => schema.required('Route is required'),
            otherwise: (schema) => schema,
        }),

        title: Yup.string()
            .max(100, 'Title should not exceed 100 characters')
            .when('is_affiliate', {
                is: true,
                then: (schema) => schema, // optional
                otherwise: (schema) => schema.required('Title is required'),
            }),

        keyword: Yup.string()
            .max(30, 'Keyword should not exceed 30 characters')
            .when('is_affiliate', {
                is: true,
                then: (schema) => schema,
                otherwise: (schema) => schema.required('Keyword is required'),
            }),

        body: Yup.string()
            // .max(200, 'Body should not exceed 200 characters')
            .when('is_affiliate', {
                is: true,
                then: (schema) => schema,
                otherwise: (schema) => schema.required('Body is required'),
            }),

        media: Yup.mixed().when('is_affiliate', {
            is: true,
            then: (schema) => schema,
            otherwise: (schema) => schema.required('File is required'),
        }),
    });

    const formik = useFormik({
        initialValues: {
            location_ids: [],
            industry_id: "",
            use_domain_info: true,
            is_affiliate: false,  // <-- new
            route: "",
            title: "",
            body: "",
            keyword: "",
            contact: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            // setvalueChangeCount(0)
            console.log("values", values);

            setDomainModal(false);
            const formData = new FormData();
            if (!selectedDomain) values.slug = slug;

            values.location_ids = values.location_ids.filter((item) => item !== 'all')
            if (fileType === "video") {
                formData.append('videos', values.media);
            }
            if (fileType === "image") {
                formData.append('images', values.media);
            }
            if (selectedDomain) {
                // console.log("formData",formData);
                Object.keys(values).forEach((key) => {
                    const value = values[key];

                    if (key !== 'media') {
                        formData.append(key, value);
                    }
                });
                values.id = selectedDomain.uuid;
                dispatch(updateDomain({ formData, id: selectedDomain.uuid })).then((res) => {
                    fetchDomainsDetails()
                })
            } else {
                console.log("formData", formData);

                Object.keys(values).forEach((key) => {
                    const value = values[key];

                    if (key !== 'media' && value !== undefined && value !== null && value !== '') {
                        formData.append(key, value);
                    }
                });
                dispatch(createDomain(formData)).then((res) => {
                    fetchDomainsDetails()
                })
            }
        },
    });

    useEffect(() => {
        if (selectedDomain && domainModal) {
            const selectedLocations = selectedDomain.locations?.map(loc => loc.id)

            const isAll = _.isEqual([...selectedLocations].sort(), [...allLocationIds].sort())

            formik.setValues({
                location_ids: isAll ? ["all", ...selectedLocations] : selectedLocations || [],
                body: selectedDomain.body || '',
                use_domain_info: selectedDomain.use_domain_info,
                is_affiliate: selectedDomain.is_affiliate,
                industry_id: selectedDomain.industries[0]?.id || '',
                keyword: selectedDomain.keyword || '',
                title: selectedDomain.title || '',
                contact: selectedDomain.contact || '',
                route: selectedDomain.route || '',
                media: selectedDomain.photos[0]?.image || selectedDomain.photos[0]?.video || selectedDomain.photos[0]?.external_url,
            });
            setFilePreview(selectedDomain.photos[0]?.image || selectedDomain.photos[0]?.video || selectedDomain.photos[0]?.external_url);
            setFileType(selectedDomain.photos[0]?.image ? 'image' : selectedDomain.photos[0]?.video ? 'video' : selectedDomain.photos[0]?.external_url ? selectedDomain.photos[0]?.file_type : null);
        } else {
            formik.resetForm();
            setFilePreview(null);
        }
    }, [selectedDomain, domainModal, resetTrigger]);

    useEffect(() => {
        if (selectedDomain?.route) {

            const normalizePhone = (phone) => phone.replace(/[^0-9]/g, '');
            const disabled = isEqual(
                {
                    location_ids: formik.values.location_ids,
                    industry_id: formik.values.industry_id,
                    use_domain_info: formik.values.use_domain_info,
                    is_affiliate: formik.values.is_affiliate,
                    body: formik.values.body || '',
                    title: formik.values.title || '',
                    contact: formik.values.contact || '',
                    route: formik.values.route || '',
                },
                {
                    industry_id: selectedDomain.industries[0]?.id || '',
                    location_ids: selectedDomain.locations?.map(loc => loc.id) || [],
                    use_domain_info: selectedDomain.use_domain_info,
                    is_affiliate: selectedDomain.is_affiliate,
                    title: selectedDomain.title || '',
                    contact: selectedDomain.contact || '',
                    route: selectedDomain.route || '',
                    body: selectedDomain.body || '',
                }
            );

            // if (valueChangeCount === 0) {
            setIsButtonDisabled(disabled)
            // } else {
            //     setIsButtonDisabled(false)
            // }

        }

    }, [selectedDomain, formik.values])



    // useEffect(() => {
    //     dispatch(fetchLocations())
    // }, [])

    function generateSlug(keyword, existingSlugs = []) {
        let baseSlug = keyword.trim().toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '');

        let slug = baseSlug;
        let counter = 1;

        while (existingSlugs.includes(slug)) {
            slug = `${baseSlug}-${counter}`;
            counter++;
        }
        setSlug(slug)
        return process.env.REACT_APP_BASE_URL + slug;
    }
    useEffect(() => {
        if (formik.values.is_affiliate && !selectedDomain) {
            formik.setFieldValue('route', "");
        }
    }, [formik.values.is_affiliate])
    useEffect(() => {
        if (selectedDomain && filePreview !== formik.values.media)
            setIsButtonDisabled(false)
    }, [filePreview])


    const allOptionId = 'all';
    const allOptionLabel = 'All';
    const allLocationIds = fbLocations?.map((ele) => ele.id);


    return (
        <CommentDrawer open={domainModal} setOpen={setDomainModal}>
            <Box className=" position-relative h-100">
                <form onSubmit={formik.handleSubmit} >
                    <Typography variant="h6" gutterBottom className='p-3'>
                        {title}
                    </Typography>
                    <Divider />

                    <div className='role-form-scroller px-3'>
                        <TextField
                            fullWidth
                            required={!formik.values.is_affiliate}
                            id="keyword"
                            placeholder='Page Route Keyword'
                            name="keyword"
                            label="Route Keyword"
                            margin="normal"
                            variant="outlined"
                            className='mb-3'
                            value={formik.values.keyword}
                            onChange={(e) => {
                                const value = e.target.value;
                                const filteredValue = value.replace(/[^a-zA-Z0-9 ]/g, ''); // blocks special chars
                                formik.setFieldValue('keyword', filteredValue);
                            }}
                            onBlur={(e) => {
                                formik.handleBlur(e);
                                if (!formik.values.is_affiliate) {
                                    const newSlug = generateSlug(e.target.value);
                                    setRoute(newSlug)
                                    formik.setFieldValue('route', newSlug);
                                }
                            }}
                            disabled={selectedDomain}
                            error={formik.touched.keyword && Boolean(formik.errors.keyword)}
                            helperText={formik.touched.keyword && formik.errors.keyword}
                        />
                        <FormControl className='mt-1 mb-3' fullWidth
                        >
                            <InputLabel id="industry_id">Industry</InputLabel>
                            <Select
                                labelId="industry_id"
                                id="industry_id"
                                name='industry_id'
                                label="Industry"
                                value={formik.values?.industry_id}
                                onChange={(e) => {
                                    // setvalueChangeCount(prev => prev + 1); 
                                    formik.handleChange(e);
                                }}
                                onBlur={formik.handleBlur}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                endAdornment={
                                    formik.values.industry_id ? (
                                        <IconButton
                                            size="small"
                                            className='mr-4'
                                            onClick={() => formik.setFieldValue('industry_id', '')}
                                            onMouseDown={(event) => event.stopPropagation()}
                                        >
                                            <CloseRounded />
                                        </IconButton>
                                    ) : null
                                }

                            >
                                {(!industries || industries?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No Industry found.
                                    </MenuItem>
                                )}
                                {industries?.length && industries?.map((ele) => <MenuItem value={ele.id}>{ele.title}</MenuItem>)}
                            </Select>

                        </FormControl>
                        <Box className="d-flex item-align-center">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formik.values.is_affiliate}
                                        onChange={(e) => {
                                            // setvalueChangeCount(prev=>prev+1)
                                            formik.setFieldValue('route', route);
                                            formik.setFieldValue('is_affiliate', e.target.checked);
                                        }}
                                        color="primary"
                                    />
                                }
                                label="Use Affiliate Link"
                                sx={{
                                    '& .MuiFormControlLabel-label': {
                                        fontSize: '0.875rem',
                                        color: 'primary.main',
                                    },
                                }}
                                disabled={selectedDomain}
                            />
                        </Box>
                        <TextField
                            fullWidth
                            required
                            id="route"
                            name="route"
                            className="mt-1 mb-3"
                            label="Route"
                            placeholder="Route"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.route}
                            onChange={(e) => {
                                // setvalueChangeCount(prev => prev + 1); 
                                formik.handleChange(e);
                            }}
                            onBlur={formik.handleBlur}
                            disabled={selectedDomain ? true : !formik.values.is_affiliate}
                            error={formik.touched.route && Boolean(formik.errors.route)}
                            helperText={formik.touched.route && formik.errors.route}
                        />


                        {!formik.values.is_affiliate && <TextField
                            fullWidth
                            required={!formik.values.is_affiliate}
                            id="title"
                            name="title"
                            placeholder='Page Title'
                            label="Title"
                            className='mt-1 mb-3'
                            margin="normal"
                            variant="outlined"
                            value={formik.values.title}
                            onChange={(e) => {
                                // setvalueChangeCount(prev => prev + 1); 
                                formik.handleChange(e);
                            }}
                            onBlur={formik.handleBlur}
                            disabled={formik.values.is_affiliate}
                            error={formik.touched.title && Boolean(formik.errors.title)}
                            helperText={formik.touched.title && formik.errors.title}
                        />}

                        {!formik.values.is_affiliate &&
                            <>
                                {/* <TextField
                                    fullWidth
                                    required={!formik.values.is_affiliate}
                                    multiline
                                    rows={3}
                                    id="body"
                                    name="body"
                                    placeholder='Page Body'
                                    label="Body"
                                    margin="normal"
                                    className='mt-1 mb-3'
                                    variant="outlined"
                                    value={formik.values.body}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled={formik.values.is_affiliate}
                                    error={formik.touched.body && Boolean(formik.errors.body)}
                                    helperText={formik.touched.body && formik.errors.body}
                                /> */}
                                <Box className='mt-1 mb-3'

                                >
                                    <Editor
                                        id="body"
                                        name="body"
                                        label="Body"
                                        className='m-1'
                                        style={{
                                            minHeight: '200px',         // outer container height
                                        }}
                                        containerProps={{
                                            style: {
                                                minHeight: '200px',       // inner iframe container
                                            },
                                        }}
                                        // required={!formik.values.is_affiliate}
                                        value={formik.values.body}
                                        onChange={(e) => {
                                            // setvalueChangeCount(prev => prev + 1);
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                        placeholder='Page Body'
                                        disabled={formik.values.is_affiliate}
                                    />
                                    {
                                        formik.touched.body && formik.errors.body && (
                                            <FormHelperText className="text-danger">{formik.errors.body}</FormHelperText>
                                        )
                                    }
                                </Box>
                            </>
                        }
                        <FormControl fullWidth className="mt-1 mb-1 location-select-wrapper"
                            error={formik.touched.location_ids && Boolean(formik.errors.location_ids)}
                        >
                            <InputLabel id="location_ids">Location</InputLabel>
                            <Select
                                labelId="location_ids"
                                id="location_ids"
                                name="location_ids"
                                label="Location"
                                className=''
                                multiple
                                value={formik.values.location_ids || []} // must stay array
                                // onChange={(event) => {
                                //     formik.setFieldValue('location_ids', event.target.value);
                                // }}

                                onChange={(event) => {
                                    const value = event.target.value;
                                    // setvalueChangeCount(prev=>prev+1)
                                    const isAllSelected = formik?.values?.location_ids?.includes(allOptionId);
                                    const justClickedAll = value.includes(allOptionId) && !isAllSelected;
                                    const justUnclickedAll = !value.includes(allOptionId) && isAllSelected;

                                    if (justClickedAll) {
                                        formik.setFieldValue('location_ids', [allOptionId, ...allLocationIds]);

                                    } else if (justUnclickedAll) {
                                        formik.setFieldValue('location_ids', []);
                                    } else {
                                        const filtered = value.filter(val => val !== allOptionId);

                                        if (filtered?.length === allLocationIds?.length) {
                                            formik.setFieldValue('location_ids', [allOptionId, ...filtered]);
                                        } else {
                                            formik.setFieldValue('location_ids', filtered);
                                        }
                                    }
                                }}

                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                onBlur={formik.handleBlur}
                                renderValue={(selected) => {

                                    if (selected.length === 0) {
                                        return <Typography color="textSecondary">Select locations</Typography>;
                                    } else {
                                        return (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }} className="multi-selection-box-wrapper">
                                                {selected?.map((id) => {
                                                    const location = fbLocations?.find((ele) => ele.id === id);
                                                    return (
                                                        location && <Chip
                                                            key={id}
                                                            label={location?.display_name || id}
                                                            onMouseDown={(e) => e.stopPropagation()}
                                                            onDelete={() => {
                                                                const newSelected = formik.values.location_ids.filter(
                                                                    item => item !== id && item !== "all"
                                                                );
                                                                formik.setFieldValue('location_ids', newSelected);
                                                            }}
                                                            className="role-permission mr-2"
                                                        />
                                                    );
                                                })}
                                            </Box>
                                        );
                                    }
                                }}
                            >
                                <MenuItem key={allOptionId} value={allOptionId}>
                                    <Checkbox checked={formik.values.location_ids?.includes(allOptionId)} />
                                    <ListItemText primary={allOptionLabel} />
                                </MenuItem>
                                {fbLocations?.length > 0 &&
                                    fbLocations?.map((ele) => (
                                        <MenuItem key={ele.id} value={ele.id}>
                                            <Checkbox checked={formik.values.location_ids.includes(ele.id)} />
                                            <ListItemText primary={ele.display_name} />
                                        </MenuItem>
                                    ))
                                }
                            </Select>

                            {formik.touched.location_ids && formik.errors.location_ids && (
                                <FormHelperText className="text-danger">{formik.errors.location_ids}</FormHelperText>
                            )}
                        </FormControl>


                        {/* <TextField
                            fullWidth
                            id="contact"
                            placeholder="Contact Number"
                            name="contact"
                            label="Contact"
                            margin="normal"
                            variant="outlined"
                            inputProps={{ maxLength: 15 }} // allows up to 15 characters
                            value={formik.values.contact}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.contact && Boolean(formik.errors.contact)}
                            helperText={formik.touched.contact && formik.errors.contact}
                            onBeforeInput={(e) => {
                                if (!/[\d+]/.test(e.data)) {
                                    e.preventDefault();
                                }
                            }}
                        /> */}
                        {!formik.values.is_affiliate && <Box sx={{ mt: 1.5 }}>
                            <PhoneInput
                                country={'us'}
                                value={formik.values.contact}
                                onChange={(value, countryData, e, formattedValue) => {
                                    // setvalueChangeCount(prev=>prev+1)
                                    formik.setFieldValue('contact', formattedValue);
                                }}
                                placeholder="Enter phone number"
                                inputProps={{
                                    name: 'contact',
                                    required: !formik.values.is_affiliate,
                                    autoFocus: false,
                                    onBlur: formik.handleBlur, // Important to trigger validation on blur
                                }}
                                inputStyle={{
                                    width: '100%',
                                    marginTop: '16px',
                                    marginBottom: '8px',
                                    // padding: '10px',
                                    height: '55px',
                                    borderRadius: '4px',
                                    backgroundColor: '#FAFBF8',
                                    border: formik.touched.contact && formik.errors.contact
                                        ? '1px solid #dc3545'
                                        : '1px solid #ccc',
                                }}
                                containerStyle={{
                                    marginBottom: '16px',
                                }}
                            />
                        </Box>}
                        {formik.touched.contact && formik.errors.contact && (
                            <div style={{ color: '#dc3545', marginBottom: '7px', fontSize: '12px' }}>
                                {formik.errors.contact}
                            </div>
                        )}

                        {!formik.values.is_affiliate &&
                            <FileUploader formik={formik}
                                accept={{
                                    'image/*': [],
                                    'video/*': []
                                }}
                                isRequired={!formik.values.is_affiliate}
                                label="Upload Image/Video" {...{ fileType, setFileType, filePreview, setFilePreview }} tooltipMsg="Upload a single image or video to display as the domain background" name="media" />
                        }

                        {/* <Box className="mt-3 d-flex item-align-center" style={{
                            visibility: "hidden"
                        }}>
                            <FormControlLabel
                                className='ml-1'
                                control={
                                    <CustomSwitch
                                        checked={formik.values.use_domain_info}
                                        value={formik.values.use_domain_info}
                                        onChange={(e) => {
                                            console.log("checked", e.target.checked);
                                            formik.setFieldValue("use_domain_info", e.target.checked);
                                        }}
                                    />
                                }

                                sx={{
                                    '& .MuiFormControlLabel-label': {
                                        fontSize: '0.875rem', // 14px
                                        color: 'primary.main',
                                    },
                                }}
                            />
                            <Box display="flex" className="mt-1">
                                <Typography variant='body2' color='primary' >Turn on to use contact info in auto reply</Typography>
                                <Tooltip title="When turned OFF, a default message such as 'send us a direct message'—defined in the global settings—will be used instead.">
                                    <InfoIcon fontSize="small" className='ml-2' color="primary" />
                                </Tooltip>
                            </Box>
                        </Box> */}
                    </div>
                    <Box className="drawer-footer m-3">
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                //  setvalueChangeCount(0); 
                                setDomainModal(false);
                            }}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="mt-2"
                            disabled={selectedDomain ? (isButtonDisabled || !formik.isValid) : !(formik.dirty && formik.isValid)}
                        >
                            Save
                        </Button>
                    </Box>
                </form>
            </Box>
        </CommentDrawer>
    );
}